<template>
    <component :is="iconComponent" class="flex-none" :class="sizeClass" />
</template>

<script setup>
import * as SolidIcons from '@heroicons/vue/24/solid'
import * as OutlineIcons from '@heroicons/vue/24/outline'
const props = defineProps({
    name: {
        type: String,
        required: true
    },
    solid: {
        type: Boolean,
        default: false
    },
    size: {
        type: String,
        default: 'md' // 👈 important
    }
})

const sizeMap = {
    xs: 'size-3',
    sm: 'size-4',
    md: 'size-5',
    lg: 'size-6'
}

const sizeClass = computed(() => sizeMap[props.size] ?? sizeMap.md)

// convert "arrow-left-end-on-rectangle" ➜ "ArrowLeftEndOnRectangle"
const toPascalCase = (str) =>
    str
        .split('-')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join('')

const iconComponent = computed(() => {
    const baseName = toPascalCase(props.name) + 'Icon'
    return props.solid ? SolidIcons[baseName] : OutlineIcons[baseName]
})
</script>
